import { render, staticRenderFns } from "./woocommerce-vs-shopify-quel-cms-choisir.vue?vue&type=template&id=43b9fb57&"
import script from "./woocommerce-vs-shopify-quel-cms-choisir.vue?vue&type=script&lang=js&"
export * from "./woocommerce-vs-shopify-quel-cms-choisir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports